import PolarisIcon from '@/components/_common/PolarisIcon';
import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import { UserGroup } from '../../../redux/slices/slice_types';

export type GroupDisplayProps = {
  group: UserGroup;
  emptyText?: string;
  iconSize?: number;
  canAssign?: boolean;
};

const GroupDisplay = ({ group, emptyText = 'Unassigned', iconSize = 17, canAssign }: GroupDisplayProps) => {
  const unassignedIcon = <GroupIcon id="groupIcon" icon="unassigned_group" height={iconSize} />;

  if (!group && !canAssign) return <>Unassigned</>;
  if (!group)
    return (
      <Unassigned>
        {unassignedIcon}
        {emptyText}
      </Unassigned>
    );

  const displayName = group.group;

  const getIcon = () => {
    if (displayName === 'Unassigned') return unassignedIcon;
    else return <GroupIcon id="groupIcon" icon="group" height={iconSize} />;
  };

  return (
    <Wrapper container>
      {getIcon()}
      <span>{displayName}</span>
    </Wrapper>
  );
};

export default GroupDisplay;

const Wrapper = styled(Grid)`
  line-height: 1.3;
  font-size: 0.88rem;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
`;

const Unassigned = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  opacity: 0.33;
`;

const GroupIcon = styled(PolarisIcon)`
  margin-right: ${({ theme }) => theme.spacing(0.5)};
  line-height: 1px;
  opacity: 0.66;
  position: relative;
`;
